import React, { memo } from 'react'
import styled from 'styled-components/macro'
import { ITheme } from 'styles/types'

interface IProps {
  logo: string
}

const MainLogo: React.FC<IProps> = ({ logo }) => {
  return <CustomLogo src={logo} alt="logo" />
}

export default memo(MainLogo)

const CustomLogo = styled.img`
  width: 125px;
  @media ${({ theme }: { theme: ITheme }) => theme.breakpoints.md} {
    width: 80px;
  }
`
